import PropTypes from 'prop-types'
import { Box, Button, Typography, Tooltip } from '@mui/material'
import clsx from 'clsx'

import { ReactComponent as MapPin } from '../../../../assets/icons/map-pin.svg'
import { ReactComponent as Agenda } from '../../../../assets/icons/agenda.svg'
import { ReactComponent as Sustainable } from '../../../../assets/icons/sustainable.svg'
import { ADDRESS_SOURCES } from '../../../../common/constants'

import useTranslations from '../../../../i18n/useTranslations'
import { useUserContext } from '../../../../auth/UserProvider'

import useStyles from './styles'

const propTypes = {
  children: PropTypes.node,
  addressSource: PropTypes.string,
  changeAddressSource: PropTypes.func,
}

const SourceAddressSelector = ({
  children,
  addressSource,
  changeAddressSource,
}) => {
  const classes = useStyles()
  const formatMessage = useTranslations()

  return (
    <Box component="section" className={classes.section}>
      <Typography
        variant="h2"
        className={clsx('secondaryTitle', 'decorator', classes.title)}
      >
        {formatMessage('shipping-send-form:title:origin-address')}
      </Typography>
      <Box mb={3} sx={{ display: 'flex' }}>
        <Button
          size="small"
          startIcon={<MapPin weight="regular" />}
          variant={
            addressSource === ADDRESS_SOURCES.clientCentersList
              ? 'contained'
              : 'outlined'
          }
          onClick={() => changeAddressSource(ADDRESS_SOURCES.clientCentersList)}
        >
          {formatMessage('shipping-send-form:label:contract-address')}
        </Button>
        <Button
          size="small"
          startIcon={<Agenda weight="regular" />}
          variant={
            addressSource === ADDRESS_SOURCES.newAddress
              ? 'contained'
              : 'outlined'
          }
          onClick={() => changeAddressSource(ADDRESS_SOURCES.newAddress)}
        >
          {formatMessage('shipping-send-form:label:other-address')}
        </Button>
        <Tooltip
          title={
            <Typography variant="body2">
              {formatMessage('message:most-sustainable-option')}
            </Typography>
          }
          placement="top"
          sx={{ order: '2' }}
        >
          <Button
            size="small"
            startIcon={<Sustainable weight="regular" />}
            className={clsx(
              addressSource === ADDRESS_SOURCES.pickUpPoint
                ? classes.cttExpressPointButtonContained
                : classes.cttExpressPointButtonOutlined,
            )}
            onClick={() => changeAddressSource(ADDRESS_SOURCES.pickUpPoint)}
          >
            {formatMessage('shipping-send-form:label:pick-up-point')}
          </Button>
        </Tooltip>
      </Box>
      {children}
    </Box>
  )
}

SourceAddressSelector.propTypes = propTypes

export default SourceAddressSelector
